// @flow

import { useEffect } from 'react';

import { getFirstFocusableIn } from './focus';

// $FlowFixMe - flow doesn't understand useRef
const useFocusOnShow = modalRef => {
  useEffect(() => {
    if (modalRef.current) {
      const modal = modalRef.current;

      const tabbable = getFirstFocusableIn(modal);
      if (tabbable) {
        // $FlowFixMe - flow doesn't recognize focus correctly
        tabbable.focus({ preventScroll: true });
      } else {
        modal.focus({ preventScroll: true });
      }
    }
  }, [modalRef]);
};

export default useFocusOnShow;
